export const productPaths = {
  absolute: '/:clientId/products',

  singleProduct: {
    absolute: '/:clientId/products/:productId',
    relative: ':productId',
  },
} as const;
